import React, { useEffect, useRef, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Container from "react-bootstrap/cjs/Container";
import Nav from "react-bootstrap/cjs/Nav";
import Offcanvas from "react-bootstrap/cjs/Offcanvas";
import { FaInstagram, FaTelegramPlane } from "react-icons/fa";
import "../styles/header.css";

const NAV_LINKS = [
  { to: "/", label: "главная" },
  { to: "/about/", label: "обо мне" }
];

const SocialLink = ({ href, label, children }) => {
  if (!href) return null;

  return (
    <a
      href={href}
      className="site-header__social-link"
      target="_blank"
      rel="noreferrer noopener nofollow"
      aria-label={label}
    >
      {children}
    </a>
  );
};

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const burgerRef = useRef(null);
  const lastFocusRef = useRef(null);
  const data = useStaticQuery(graphql`
    query HeaderSiteLinks {
      site {
        siteMetadata {
          links {
            telegram
            instagram
          }
        }
      }
    }
  `);

  const links = data.site.siteMetadata.links;

  useEffect(() => {
    if (!isMenuOpen || typeof document === "undefined") return;
    lastFocusRef.current =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
  }, [isMenuOpen]);

  const closeMenu = () => {
    setMenuOpen(false);

    window.setTimeout(() => {
      if (burgerRef.current) {
        burgerRef.current.focus();
        return;
      }

      if (lastFocusRef.current) {
        lastFocusRef.current.focus();
      }
    }, 0);
  };

  const renderNavLinks = (className = "") =>
    NAV_LINKS.map(({ to, label }) => (
      <Link key={to} to={to} className={className} onClick={closeMenu}>
        {label}
      </Link>
    ));

  const renderSocialLinks = () => (
    <>
      <SocialLink href={links.telegram} label="Telegram">
        <FaTelegramPlane aria-hidden="true" />
      </SocialLink>
      <SocialLink href={links.instagram} label="Instagram">
        <FaInstagram aria-hidden="true" />
      </SocialLink>
    </>
  );

  return (
    <header className="site-header">
      <Container className="site-header__inner">
        <Link to="/" className="site-header__logo" aria-label="volskaya.ink">
          <StaticImage
            src="../../data/images/volskaya.ink.png"
            alt="volskaya.ink"
            width={180}
            placeholder="blurred"
            formats={["auto", "webp"]}
            loading="eager"
            quality={100}
          />
        </Link>

        <Nav className="site-header__nav d-none d-lg-flex align-items-center">
          {renderNavLinks("site-header__nav-link")}
          <div className="site-header__socials">{renderSocialLinks()}</div>
        </Nav>

        <button
          type="button"
          className="site-header__burger d-lg-none"
          aria-label="Открыть меню"
          aria-controls="mobile-menu"
          aria-expanded={isMenuOpen}
          ref={burgerRef}
          onClick={() => setMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </Container>

      <Offcanvas
        id="mobile-menu"
        placement="start"
        show={isMenuOpen}
        onHide={closeMenu}
        className="mobile-menu-offcanvas d-lg-none"
      >
        <button
          type="button"
          className="mobile-menu-close btn-close"
          aria-label="Закрыть меню"
          onClick={closeMenu}
        />
        <Offcanvas.Body>
          <Nav className="mobile-menu-nav flex-column align-items-center">
            {renderNavLinks("mobile-menu-link")}
            <div className="mobile-menu-socials">{renderSocialLinks()}</div>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

export default Header;
